import { DeepPartial } from '@bodilenergy/util';
import { JYSKE_HEATPUMP_LOAN, JYSKE_SOLAR_LOAN, NORDEA_HEATPUMP_LOAN, NORDEA_SOLAR_LOAN } from '~src/constants';
import { useFinancingProvider } from '~src/hooks/useFinancingProvider';
import { useGenericCombinedFinancing } from '~src/hooks/useGenericCombinedFinancing';
import { OfferProducts, ProductTypes, Residence } from '~src/model';

export const useEstimatePageFinancing = (
  selectedProductTypes: ProductTypes,
  offerProducts?: DeepPartial<OfferProducts>,
  residence?: DeepPartial<Residence>
) => {
  const { provider: financingProvider } = useFinancingProvider();

  const heatPumpLoan = financingProvider === 'jyskebank' ? JYSKE_HEATPUMP_LOAN : NORDEA_HEATPUMP_LOAN;
  const solarLoan = financingProvider === 'jyskebank' ? JYSKE_SOLAR_LOAN : NORDEA_SOLAR_LOAN;

  const financing = useGenericCombinedFinancing({
    heatPumpLoan,
    solarLoan,
    selectedProductTypes,
    calculationMethod: financingProvider ?? 'nordea',
    offer: offerProducts,
    residence: residence ?? {},
  });

  return {
    financing,
    financingProvider,
  };
};
